import { useContext } from "react";
import { OnboardingContext } from "../context/OnboardingContext";

const useOnboardingContext = () => {
  const context = useContext(OnboardingContext);
  if (!context) {
    throw new Error(
      "You need to be under the onboarding provider to use this hook"
    );
  }

  return context;
};

export default useOnboardingContext
